import axios from "axios";

const API_URL = process.env.REACT_APP_HOST_API;

class AutenticacaoService {
    
    async entrar(usuario) {
        var url = `${API_URL}/v1/entrar`;
        return axios.post(url, usuario);
    }

    async recuperarSenha(email) {
        var url = `${API_URL}/v1/publico/recuperar-senha`;
        return axios.post(url, { email: email });
    }

    async resetarSenha(token, novaSenha) {
        var url = `${API_URL}/v1/publico/resetar-senha`;
        return axios.post(url, { token: token, novaSenha: novaSenha });
    }
}

export default new AutenticacaoService();
